import React from 'react';
import { authRoles } from 'app/auth';

export const CoursesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: [...authRoles.user, ...authRoles.instructor, ...authRoles.participant], //['admin', 'staff', 'user']
	routes: [
		{
			path: '/courses',
			component: React.lazy(() => import('./Courses'))
		}
	]
};
